<template>
  <v-list
    three-line
    style="max-width: 100%;"
  >
    <template v-for="(trainingTask) in items">
      <!-- Show only on xsOnly -->
      <v-list-item
        :key="trainingTask.proposalClassId"
        v-ripple
        :to="`/tasklist/trainingDetail/${trainingTask.proposalClassId}`"
      >
        <v-list-item-content>
          <v-list-item-title>{{ $chPtObjData('chinTaskListTitle', trainingTask) }} </v-list-item-title>
          <v-list-item-subtitle>
            <span class="primary--text mr-2">{{ $t('TaskList.WaitingApproveCount') }}：{{ trainingTask.numOfApplicants }}</span> {{ $chPtObjData('chinTaskListDesc2', trainingTask) }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </template>

    <template v-if="items !== null && items.length === 0">
      <div class="px-4 py-3">
        {{ $t('PublicServant.NoData') }}
      </div>
    </template>
  </v-list>
</template>

<script>

export default {
  props: {
    items: {
      type: Array,
      required: true
    }
  }
}
</script>
